
import { Component, Input } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';

@Component({
    selector: 'app-role-request-success',
    imports: [RouterModule],
    templateUrl: './role-request-success.component.html',
    styleUrl: './role-request-success.component.css'
})
export class RoleRequestSuccessComponent {
  
  // TODO: Skipped for migration because:
  //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
  //  and migrating would break narrowing currently.
  @Input() message: string;
}
